import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initOptional, sortObjectsArray } from '../../common/miscUtils';

const initialState = {
  allowedCompanies: [] as DealerIntegration.Components.Schemas.MilesBrokerCompaniesData[],
  currentCompany: initOptional<DealerIntegration.Components.Schemas.MilesBrokerCompaniesData>(),
  username: initOptional<string>(),
  milesSalesPersonId: initOptional<string>(),
  favouriteCompanyId: initOptional<string>(),
};

type BrokerStateType = typeof initialState;

export const brokerSlice = createSlice({
  name: 'broker',
  initialState,
  selectors: {
    username: (state: BrokerStateType) => state.username,
    currentCompany: (state: BrokerStateType) => state.currentCompany,
    allowedCompanies: (state: BrokerStateType) => state.allowedCompanies,
    allowedCompaniesSortedByBerCode: (state: BrokerStateType) =>
      sortObjectsArray([...state.allowedCompanies], (company) => company.milesBerCode || ''),
    milesSalesPersonId: (state: BrokerStateType) => state.milesSalesPersonId,
    favouriteCompanyId: (state: BrokerStateType) => state.favouriteCompanyId,
  },
  reducers: {
    setAllowedCompanies(
      state,
      { payload }: PayloadAction<DealerIntegration.Components.Schemas.MilesBrokerCompaniesData[]>
    ) {
      state.allowedCompanies = payload;
    },
    /**
     * - Never set current company without prior authentication of salesperson as this company.
     */
    setCurrentCompany(
      state,
      { payload }: PayloadAction<DealerIntegration.Components.Schemas.MilesBrokerCompaniesData>
    ) {
      state.currentCompany = payload;
    },
    setUsername(state, { payload }: PayloadAction<string>) {
      state.username = payload;
    },
    setMilesSalesPersonId(state, { payload }: PayloadAction<string>) {
      state.milesSalesPersonId = payload;
    },
    setFavouriteCompanyId(state, { payload }: PayloadAction<string | undefined>) {
      state.favouriteCompanyId = payload;
    },
  },
});

export const brokerSelectors = brokerSlice.selectors;
export const { setAllowedCompanies, setCurrentCompany, setUsername, setMilesSalesPersonId, setFavouriteCompanyId } =
  brokerSlice.actions;
export const brokerReducer = brokerSlice.reducer;
